import React, { useState, useEffect } from 'react';
import './Profile.css';

const Profile = () => {
  const [user, setUser] = useState({
    name: 'Rahul Sharma',
    email: 'rahul@example.com',
    school: 'Delhi Public School',
    city: 'New Delhi',
    grade: '10',
    stream: 'CBSE',
    avatar: '👨‍🎓',
    created_at: new Date()
  });
  
  const [stats, setStats] = useState({
    total_assessments: 12,
    average_score: 78,
    total_practice: 45,
    streak_days: 5
  });
  
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({ ...user });
  const [showAvatarSelector, setShowAvatarSelector] = useState(false);
  const [saveMessage, setSaveMessage] = useState('');
  
  // Avatar options
  const avatarOptions = {
    male: ['👨‍🎓', '👨‍💻', '👨‍🏫', '👨‍🚀', '👨‍🎨', '👨‍🍳', '👨‍🔧', '🦁', '🐯', '🐼'],
    female: ['👩‍🎓', '👩‍💻', '👩‍🏫', '👩‍🚀', '👩‍🎨', '👩‍🍳', '👩‍🔧', '🐰', '🦊', '🐱']
  };
  
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
  const handleSave = () => {
    setUser(formData);
    setIsEditing(false);
    setSaveMessage('Profile updated successfully!');
    setTimeout(() => setSaveMessage(''), 3000);
  };
  
  const handleAvatarSelect = (avatar) => {
    setFormData({ ...formData, avatar });
    setUser({ ...user, avatar });
    setShowAvatarSelector(false);
    setSaveMessage('Avatar updated!');
    setTimeout(() => setSaveMessage(''), 3000);
  };
  
  const getInitials = () => {
    return user.name.split(' ').map(n => n[0]).join('').toUpperCase();
  };
  
  return (
    <div className="profile-container">
      {/* Success Message */}
      {saveMessage && (
        <div className="save-message">
          <span>✓</span> {saveMessage}
        </div>
      )}
      
      <div className="profile-card">
        {/* Header */}
        <div className="profile-header">
          <h1>My Profile</h1>
          <p>Manage your account information</p>
        </div>
        
        {/* Avatar Section - Proper Size */}
        <div className="avatar-section">
          <div className="avatar-wrapper" onClick={() => setShowAvatarSelector(true)}>
            <div className="avatar-large">
              {user.avatar}
            </div>
            <button className="change-avatar-btn">
              <span>🖌️</span> Change Avatar
            </button>
          </div>
          
          {/* Avatar Selector Modal */}
          {showAvatarSelector && (
            <div className="avatar-modal" onClick={() => setShowAvatarSelector(false)}>
              <div className="avatar-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="avatar-modal-header">
                  <h3>Choose your avatar</h3>
                  <button className="close-btn" onClick={() => setShowAvatarSelector(false)}>✕</button>
                </div>
                <div className="avatar-grid">
                  {avatarOptions[user.gender || 'male'].map((avatar, index) => (
                    <div
                      key={index}
                      className={`avatar-option ${user.avatar === avatar ? 'selected' : ''}`}
                      onClick={() => handleAvatarSelect(avatar)}
                    >
                      {avatar}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
        
        {/* Stats Row */}
        <div className="stats-row">
          <div className="stat-item">
            <span className="stat-value">{stats.total_assessments}</span>
            <span className="stat-label">Assessments</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">{stats.average_score}%</span>
            <span className="stat-label">Avg Score</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">{stats.total_practice}</span>
            <span className="stat-label">Practice</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">🔥 {stats.streak_days}</span>
            <span className="stat-label">Day Streak</span>
          </div>
        </div>
        
        {/* Profile Info */}
        <div className="profile-info">
          {!isEditing ? (
            // View Mode
            <>
              <div className="info-row">
                <div className="info-label">Full Name</div>
                <div className="info-value">{user.name}</div>
              </div>
              <div className="info-row">
                <div className="info-label">Email</div>
                <div className="info-value">{user.email}</div>
              </div>
              <div className="info-row">
                <div className="info-label">School</div>
                <div className="info-value">{user.school}</div>
              </div>
              <div className="info-row">
                <div className="info-label">City</div>
                <div className="info-value">{user.city}</div>
              </div>
              <div className="info-row">
                <div className="info-label">Grade</div>
                <div className="info-value">Grade {user.grade}</div>
              </div>
              <div className="info-row">
                <div className="info-label">Stream</div>
                <div className="info-value">{user.stream}</div>
              </div>
              
              <button className="edit-btn" onClick={() => setIsEditing(true)}>
                Edit Profile
              </button>
            </>
          ) : (
            // Edit Mode
            <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>School</label>
                <input
                  type="text"
                  name="school"
                  value={formData.school}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>City</label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Grade</label>
                  <select name="grade" value={formData.grade} onChange={handleInputChange}>
                    {[6,7,8,9,10,11,12].map(g => <option key={g}>{g}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Stream</label>
                  <select name="stream" value={formData.stream} onChange={handleInputChange}>
                    <option>CBSE</option>
                    <option>ICSE</option>
                  </select>
                </div>
              </div>
              
              <div className="form-actions">
                <button type="button" className="cancel-btn" onClick={() => setIsEditing(false)}>Cancel</button>
                <button type="submit" className="save-btn">Save Changes</button>
              </div>
            </form>
          )}
        </div>
        
        {/* Change Password Section */}
        <div className="password-section">
          <h3>Change Password</h3>
          <form onSubmit={(e) => {
            e.preventDefault();
            setSaveMessage('Password changed successfully!');
            setTimeout(() => setSaveMessage(''), 3000);
            e.target.reset();
          }}>
            <div className="form-group">
              <label>Current Password</label>
              <input type="password" required />
            </div>
            <div className="form-group">
              <label>New Password</label>
              <input type="password" required />
            </div>
            <div className="form-group">
              <label>Confirm Password</label>
              <input type="password" required />
            </div>
            <button type="submit" className="password-btn">Update Password</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Profile;